import React from 'react'
import { CreditCard, Plus, Building } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const Banks: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Bank Management</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Manage bank accounts and financial institutions</p>
        </div>
        <Button><Plus className="w-4 h-4 mr-2" />Add Bank Account</Button>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CreditCard className="w-5 h-5" />Banking Setup
          </CardTitle>
          <CardDescription>Bank accounts and payment method configuration</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Building className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Bank Management</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Configure banking and payment methods</p>
            <Button variant="outline">Setup Banking</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
